import React from "react";
import CheckItem from "../../../components/CheckItem";
import TableLogComponents from "../../../components/TableLogComponents";
export default function GrowthTable() {
  return (
    <div className="box-table-history_illness">
      <TableLogComponents
        columns={[
          {
            title: <CheckItem callBack={(check) => {}} />,
            dataIndex: "check",
            key: "check",
          },
          {
            title: "First Name",
            dataIndex: "firstname",
            key: "firstname",
          },
          {
            title: "Last Name",
            dataIndex: "lastname",
            key: "lastname",
          },
          {
            title: "Term",
            dataIndex: "term",
            key: "term",
          },
          {
            title: "Height ",
            dataIndex: "height",
            key: "height",
          },
          {
            title: "Weight",
            dataIndex: "weight",
            key: "weight",
          },
          {
            title: "Date/Time",
            dataIndex: "datetime",
            key: "datetime",
          },
          {
            title: "ID",
            dataIndex: "id",
            key: "id",
          },
          {
            title: "Class",
            dataIndex: "class",
            key: "class",
          },
          {
            title: "Room",
            dataIndex: "room",
            key: "room",
          },
          {
            title: "Advisor",
            dataIndex: "advisor",
            key: "advisor",
          },
        ]}
        dataSource={[
          {
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"1"}
              </div>
            ),
            firstname: "firstname 1",
            lastname: "lastname 1",
            term: "1/2564",
            height: "165 cm",
            weight: "45kg",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          },
          {
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"2"}
              </div>
            ),
            firstname: "firstname 2",
            lastname: "lastname 2",
            term: "1/2564",
            height: "165 cm",
            weight: "45kg",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          },
          {
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"3"}
              </div>
            ),
            firstname: "firstname 3",
            lastname: "lastname 3",
            term: "1/2564",
            height: "165 cm",
            weight: "45kg",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          },
          {
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"4"}
              </div>
            ),
            firstname: "firstname 4",
            lastname: "lastname 4",
            term: "1/2564",
            height: "165 cm",
            weight: "45kg",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          },
          {
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"5"}
              </div>
            ),
            firstname: "firstname 5",
            lastname: "lastname 5",
            term: "1/2564",
            height: "165 cm",
            weight: "45kg",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          },
          {
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"6"}
              </div>
            ),
            firstname: "firstname 6",
            lastname: "lastname 6",
            term: "1/2564",
            height: "165 cm",
            weight: "45kg",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          },
          {
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"7"}
              </div>
            ),
            firstname: "firstname 7",
            lastname: "lastname 7",
            term: "1/2564",
            height: "165 cm",
            weight: "45kg",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          },
          {
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"8"}
              </div>
            ),
            firstname: "firstname 8",
            lastname: "lastname 8",
            term: "1/2564",
            height: "165 cm",
            weight: "45kg",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          },
          {
            check: (
              <div className="row-gab1">
                <CheckItem callBack={(check) => {}} />
                {"9"}
              </div>
            ),
            firstname: "firstname 9",
            lastname: "lastname 9",
            term: "1/2564",
            height: "165 cm",
            weight: "45kg",
            datetime: "01/01/65 \n 15:50",
            id: "ID 1",
            class: "M5",
            room: "1",
            advisor: "T.Pattarapon",
          },
        ]}
      />
    </div>
  );
}
